import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import "./styles.css";

import { Parallax, Pagination, Navigation, Autoplay } from "swiper/modules";
import { awards2025 } from "../lib/awardsWinners";

export const WinnerSlider = ({ visibility = true }) => {
  const getImageUrl = (data) => {
    const base =
      "https://eventimages2.s3.ap-south-1.amazonaws.com/winners/2025";
    const imageName = data.image || `${data.name}.jpg`;

    if (data.province) {
      return `${base}/general-education/${data.province.replace(/\s+/g, "-").toLowerCase()}/${imageName}`;
    }
    return `${base}/higher-education/${imageName}`;
  };

  const awardsDetails = [...awards2025];

  return (
    <div
      className="flex flex-col h-full min-h-screen judges-bg-color py-10 lg:py-20 relative"
      id="judges"
    >
      <div className="text-center relative z-20">
        <h1
          className="text-4xl font-bold sm:text-6xl capitalize tracking-wider text-[#dd7538] lg:my-0 px-4 lg:px-0 section-title relative mx-auto w-fit"
          style={{ fontFamily: "Bebas Neue" }}
          data-aos="fade-left"
          data-aos-delay="100"
        >
          WINNERS OF NATIONAL EDUCATOR AWARDS 2025
        </h1>
      </div>
      <div className="py-4 sm:py-28">
        <Swiper
          style={{
            "--swiper-navigation-color": "#fff",
            "--swiper-pagination-color": "#fff",
            position: "absolute",
          }}
          speed={600}
          parallax={true}
          pagination={{
            clickable: true,
            type: "bullets",
            bulletClass: "swiper-pagination-bullet images-bullet",
          }}
          navigation={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Parallax, Pagination, Navigation, Autoplay]}
          className="judge-swiper winners-swiper h-[90vh] top-0 w-full"
          slidesPerView={1}
          spaceBetween={30}
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
        >
          {/* <div
            slot="container-start"
            className="parallax-bg-judge"
            data-swiper-parallax="-23%"
          ></div> */}
          {awardsDetails.map((data, index) => (
            // <div
            //   className="w-fit object-contain font-semibold bg-slate-100 rounded-md p-2.5 lg:p-4 flex flex-row justify-center items-center hover:cursor-pointer hover:text-white hover:bg-orange-500  transition-all hover:-translate-y-1"
            //   data-aos="fade-down"
            //   data-aos-delay={100 + 50 * index}
            //   key={data}
            // >
            <SwiperSlide key={index}>
              <div className="winner-card">
                <img
                  src={getImageUrl(data)}
                  alt={data.name}
                  className="w-[560px] rounded-lg h-80 object-cover"
                  loading="lazy"
                />
                <h2 className="text-white text-center font-medium text-xl lg:text-2xl mt-4 px-3">
                  {data.name || "Name not found"}
                </h2>
                <h4 className="text-gray-400 text-center font-medium text-base lg:text-lg mt-3">
                  {data.category} |{" "}
                  <span
                    className={`${
                      data.award === "Gold"
                        ? "text-yellow-600"
                        : data.award === "Silver"
                          ? "text-gray-500"
                          : "text-orange-700"
                    }`}
                  >
                    {data.award.charAt(0).toUpperCase() + data.award.slice(1)}
                  </span>
                </h4>
              </div>
            </SwiperSlide>
            // </div>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
